var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatStock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 0H8C3.58172 0 0 3.58172 0 8V68C0 72.4183 3.58172 76 8 76H68C72.4183 76 76 72.4183 76 68V8C76 3.58172 72.4183 0 68 0Z",
    fill: "#FCEBE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6065 55.4004H21.5292C21.2646 55.4004 21 55.1358 21 54.8712V21.5292V21.5292C21 21.0184 21.7952 21 22.3061 21H53.2835C54.3419 21 55.4004 21.7939 55.4004 23.1169V54.6065C55.4004 55.1358 54.8712 55.4004 54.6065 55.4004Z",
    fill: "#F78670"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7607 21H41.6408V31.3201L38.2008 28.9386L34.7607 31.3201V21Z",
    fill: "#02475E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatStock);
export default __webpack_public_path__ + "static/media/WhatStock.ea4f6dac76e942ea17cb4e792a59e05c.svg";
export { ForwardRef as ReactComponent };